import { Colors, FInter } from "@brg/ui";
import { LayoutConst } from "core/modules/layout.module";
import styled from "styled-components";

export const CampusTypesBarWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: fit-content;
    min-height: 24px;
    max-height: 24px;
    height: 24px;
    margin-right: 16px;

    * {
    &::-webkit-scrollbar {
      height: 1px;
      width: 2px;
    }
    &::-webkit-scrollbar-track {
      border-radius: 10px;
      background: ${({ theme }) => theme.competition.input.bgActive} !important;
    }
    &::-webkit-scrollbar-thumb {
      background: ${Colors.galBlack21};
    }
`;

export const HoverItemTextCampusTypesBar = styled(FInter.SmallText)`
  letter-spacing: -0.02em;
  font-size: 17px;
  line-height: 22px;
  white-space: nowrap;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 7px;
  .item-prefix {
    color: ${Colors.geoWhite47};
  }
  .item-value {
    color: ${Colors.galBlack100};
  }
  @media (max-width: ${LayoutConst.screen.mac13 }px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 15px;
    line-height: 20px;
  }
`;import { Colors, FInter } from "@brg/ui";
import { LayoutConst } from "core/modules/layout.module";
import styled from "styled-components";

export const CampusTypesBarWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: fit-content;
    min-height: 24px;
    max-height: 24px;
    height: 24px;
    margin-right: 16px;

    * {
    &::-webkit-scrollbar {
      height: 1px;
      width: 2px;
    }
    &::-webkit-scrollbar-track {
      border-radius: 10px;
      background: ${({ theme }) => theme.competition.input.bgActive} !important;
    }
    &::-webkit-scrollbar-thumb {
      background: ${Colors.galBlack21};
    }
`;

export const HoverItemTextCampusTypesBar = styled(FInter.SmallText)`
  letter-spacing: -0.02em;
  font-size: 17px;
  line-height: 22px;
  white-space: nowrap;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 7px;
  .item-prefix {
    color: ${Colors.geoWhite47};
  }
  .item-value {
    color: ${Colors.galBlack100};
  }
  @media (max-width: ${LayoutConst.screen.mac13 }px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 15px;
    line-height: 20px;
  }
`;